export default __webpack_public_path__ + "static/media/services.46ee517a.jpg";